/* Stay Around The Table: page behaviour for sections/satt-*.liquid.
   Every section renders this file, so the boot guard makes it run once.
   Theme editor: shopify:section:load re-initialises the reloaded section. */
(function () {
  if (window.__sattBoot) return;
  window.__sattBoot = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Click a [data-burst] CTA and enzyme dots + sparkles burst out of it. */
  if (!reduce) {
    document.addEventListener('click', function (ev) {
      var t = ev.target && ev.target.closest && ev.target.closest('.satt [data-burst]');
      if (!t) return;
      var r = t.getBoundingClientRect();
      var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
      var layer = document.createElement('div');
      layer.setAttribute('style', 'position:fixed;left:0;top:0;width:0;height:0;z-index:9999;pointer-events:none');
      document.body.appendChild(layer);
      var STAR = 'polygon(50% 0%,58% 42%,100% 50%,58% 58%,50% 100%,42% 58%,0% 50%,42% 42%)';
      for (var i = 0; i < 18; i++) {
        (function (i) {
          var star = i % 3 === 0;
          var s = star ? 10 : (i % 2 ? 5 : 4);
          var a = (i / 18) * Math.PI * 2 + Math.random() * 0.4;
          var d = 46 + Math.random() * 54;
          var b = document.createElement('i');
          b.setAttribute('style', 'position:fixed;left:' + cx + 'px;top:' + cy + 'px;width:' + s + 'px;height:' + s + 'px;margin:' + (-s / 2) + 'px 0 0 ' + (-s / 2) + 'px;background:' + (star ? '#F2EAD9' : '#C8A87C') + ';' + (star ? 'clip-path:' + STAR + ';' : 'border-radius:999px;') + 'opacity:0;transform:translate(0,0) scale(.3);transition:transform 720ms cubic-bezier(.16,.9,.28,1) ' + (i * 12) + 'ms, opacity 720ms ease-out ' + (i * 12) + 'ms');
          layer.appendChild(b);
          setTimeout(function () {
            b.style.opacity = '0.95';
            b.style.transform = 'translate(' + (Math.cos(a) * d).toFixed(1) + 'px,' + (Math.sin(a) * d - 10).toFixed(1) + 'px) scale(1) rotate(' + (star ? 90 : 0) + 'deg)';
          }, 24);
          setTimeout(function () { b.style.transition = 'opacity 340ms ease-in'; b.style.opacity = '0'; }, 500);
        })(i);
      }
      setTimeout(function () { layer.remove(); }, 1500);
    }, true);
  }

  /* Scroll effects: the film opens from letterboxed + rounded to full bleed,
     and the capsule fans out its sixteen enzyme dots once it scrolls into view. */
  var ticking = false;
  function fx() {
    ticking = false;
    if (reduce) return;
    var vh = window.innerHeight || 1;
    var films = document.querySelectorAll('.satt [data-film-frame]');
    for (var f = 0; f < films.length; f++) {
      var film = films[f];
      var r = film.getBoundingClientRect();
      var p = (vh * 0.9 - r.top) / (vh * 0.62);
      p = Math.max(0, Math.min(1, p));
      var k = 1 - p;
      film.style.clipPath = 'inset(' + (16 * k).toFixed(2) + '% ' + (7 * k).toFixed(2) + '% ' + (16 * k).toFixed(2) + '% ' + (7 * k).toFixed(2) + '% round ' + (34 * k).toFixed(1) + 'px)';
      film.style.transform = 'scale(' + (0.955 + 0.045 * p).toFixed(4) + ')';
    }
    var wraps = document.querySelectorAll('.satt [data-enz-wrap]:not([data-enz-on])');
    for (var w = 0; w < wraps.length; w++) {
      var wr = wraps[w].getBoundingClientRect();
      if (wr.top < vh * 0.82 && wr.bottom > vh * 0.1) {
        wraps[w].setAttribute('data-enz-on', '');
        var dots = wraps[w].querySelectorAll('[data-enz]');
        for (var i = 0; i < dots.length; i++) {
          var fan = 'pc-enz' + dots[i].getAttribute('data-enz') + ' 0.9s cubic-bezier(.2,.8,.2,1) ' + (i * 45) + 'ms both';
          var dur = (2.6 + (i % 5) * 0.45).toFixed(2);
          dots[i].style.animation = fan + ', pc-twinkle ' + dur + 's ease-in-out ' + (900 + i * 130) + 'ms infinite';
        }
      }
    }
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(fx); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  /* Film: nothing autoplays. The round button starts the film with sound; while it
     plays, a small pause button sits in the corner and a click on the film pauses it.
     Phones play the mobile cut when one is uploaded (CSS shows one <video> at a time).
     State lives on [data-satt-film] as data-film-state = idle | playing | paused. */
  var phoneMq = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
  function isPhone() { return !!(phoneMq && phoneMq.matches); }
  function activeVideo(sec) {
    var vs = sec.querySelectorAll('[data-campaign-film]');
    for (var i = 0; i < vs.length; i++) { if (vs[i].getClientRects().length) return vs[i]; }
    return vs[0] || null;
  }
  function pauseOthers(keep) {
    var all = document.querySelectorAll('.satt video, .satt-modal video');
    for (var i = 0; i < all.length; i++) { if (all[i] !== keep && !all[i].paused) all[i].pause(); }
  }
  function playFilm(sec) {
    var v = activeVideo(sec);
    if (!v) return;
    pauseOthers(v);
    v.muted = false;
    var pr = v.play();
    if (pr && pr.catch) pr.catch(function (err) {
      if (err && err.name === 'NotAllowedError') { v.muted = true; v.play().catch(function () {}); }
    });
  }
  function initFilm(root) {
    var secs = root.matches && root.matches('[data-satt-film]') ? [root] : root.querySelectorAll('[data-satt-film]');
    for (var i = 0; i < secs.length; i++) {
      var v = activeVideo(secs[i]);
      if (v && v.preload === 'none') v.preload = 'metadata';
    }
  }
  function onMedia(ev) {
    var v = ev.target;
    if (!v || !v.hasAttribute || !v.hasAttribute('data-campaign-film')) return;
    var sec = v.closest('[data-satt-film]');
    if (!sec) return;
    if (ev.type === 'play') sec.setAttribute('data-film-state', 'playing');
    else if (ev.type === 'pause' && !v.ended) sec.setAttribute('data-film-state', 'paused');
    else if (ev.type === 'ended') {
      sec.setAttribute('data-film-state', 'idle');
      try { v.currentTime = 0; } catch (e) {}
    }
  }
  document.addEventListener('play', onMedia, true);
  document.addEventListener('pause', onMedia, true);
  document.addEventListener('ended', onMedia, true);
  if (phoneMq) {
    var onBp = function () {
      var secs = document.querySelectorAll('[data-satt-film]');
      for (var i = 0; i < secs.length; i++) {
        var vs = secs[i].querySelectorAll('[data-campaign-film]');
        for (var j = 0; j < vs.length; j++) { if (!vs[j].paused) vs[j].pause(); }
        secs[i].setAttribute('data-film-state', 'idle');
      }
      initFilm(document);
    };
    if (phoneMq.addEventListener) phoneMq.addEventListener('change', onBp);
    else if (phoneMq.addListener) phoneMq.addListener(onBp);
  }

  /* Hub film cards: play the film in a pop-up on the page instead of leaving it. */
  var modal, mVideo, mTitle, mClose, lastFocus;
  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'satt-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML = '<button type="button" class="satt-modal-x" aria-label="Close">&times;</button>' +
      '<div class="satt-modal-box"><video controls playsinline preload="none"></video><p class="satt-modal-title"></p></div>';
    document.body.appendChild(modal);
    mVideo = modal.querySelector('video');
    mTitle = modal.querySelector('.satt-modal-title');
    mClose = modal.querySelector('.satt-modal-x');
    modal.addEventListener('click', function (ev) {
      if (!ev.target.closest('.satt-modal-box')) closeModal();
    });
    mVideo.addEventListener('loadedmetadata', function () {
      if (mVideo.videoWidth && mVideo.videoHeight) modal.style.setProperty('--r', mVideo.videoWidth / mVideo.videoHeight);
    });
  }
  function openModal(card) {
    if (!modal) buildModal();
    var m = isPhone() && card.getAttribute('data-src-m') ? '-m' : '';
    var src = card.getAttribute('data-src' + m);
    if (!src) return;
    modal.style.setProperty('--r', parseFloat(card.getAttribute('data-ratio' + m)) || 16 / 9);
    var poster = card.getAttribute('data-poster' + m);
    if (poster) mVideo.setAttribute('poster', poster); else mVideo.removeAttribute('poster');
    mVideo.src = src;
    mTitle.textContent = card.getAttribute('data-title') || '';
    modal.setAttribute('aria-label', mTitle.textContent || 'Film');
    lastFocus = card;
    pauseOthers(mVideo);
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    mClose.focus();
    var pr = mVideo.play();
    if (pr && pr.catch) pr.catch(function () {});
  }
  function closeModal() {
    if (!modal || !modal.classList.contains('is-open')) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    mVideo.pause();
    mVideo.removeAttribute('src');
    mVideo.load();
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('keydown', function (ev) {
    if (!modal || !modal.classList.contains('is-open')) return;
    if (ev.key === 'Escape') closeModal();
    else if (ev.key === 'Tab') {
      var f = [mClose, mVideo], i = f.indexOf(document.activeElement);
      ev.preventDefault();
      f[(i + (ev.shiftKey ? f.length - 1 : 1)) % f.length].focus();
    }
  });

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var card = t.closest('.satt [data-satt-modal]');
    if (card) { ev.preventDefault(); openModal(card); return; }
    var sec = t.closest('[data-satt-film]');
    if (!sec) return;
    if (t.closest('[data-satt-pause]')) { var p = activeVideo(sec); if (p) p.pause(); return; }
    if (t.closest('[data-satt-play]')) { playFilm(sec); return; }
    if (t.closest('[data-film-stage]')) {
      if (sec.getAttribute('data-film-state') === 'playing') { var v = activeVideo(sec); if (v) v.pause(); }
      else playFilm(sec);
    }
  });

  /* Slideshow: crossfade, caption, counter, dots, arrows, autoplay. */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function initSlides(root) {
    var els = root.querySelectorAll('[data-satt-slider]');
    for (var e = 0; e < els.length; e++) {
      (function (el) {
        if (el.__satt) clearInterval(el.__satt.t);
        var slides = el.querySelectorAll('[data-slide]');
        var dots = el.querySelectorAll('[data-dot]');
        var cap = el.querySelector('[data-slide-caption]');
        var count = el.querySelector('[data-slide-count]');
        var n = slides.length;
        if (!n) return;
        var st = el.__satt = { cur: 0, t: null };
        var ms = parseInt(el.getAttribute('data-interval'), 10) || 4600;
        function show(i) {
          st.cur = (i + n) % n;
          for (var s = 0; s < n; s++) {
            var on = s === st.cur;
            slides[s].style.opacity = on ? '1' : '0';
            slides[s].style.transform = 'scale(' + (on ? 1.04 : 1) + ')';
            if (dots[s]) {
              dots[s].style.width = on ? '38px' : '18px';
              dots[s].style.background = on ? '#E3D5BC' : 'rgba(255,255,255,0.3)';
              dots[s].setAttribute('aria-current', on ? 'true' : 'false');
            }
          }
          if (cap) cap.textContent = slides[st.cur].getAttribute('data-caption') || '';
          if (count) count.textContent = pad(st.cur + 1) + ' / ' + pad(n);
        }
        function auto() {
          clearInterval(st.t);
          if (!reduce && n > 1) st.t = setInterval(function () { show(st.cur + 1); }, ms);
        }
        function go(i) { show(i); auto(); }
        var prev = el.querySelector('[data-slide-prev]'), next = el.querySelector('[data-slide-next]');
        if (prev) prev.onclick = function () { go(st.cur - 1); };
        if (next) next.onclick = function () { go(st.cur + 1); };
        for (var d = 0; d < dots.length; d++) {
          (function (d) { dots[d].onclick = function () { go(d); }; })(d);
        }
        show(0);
        auto();
      })(els[e]);
    }
  }

  /* Sticky bar: keep the page's last content (the store footer) clear of it. */
  function sticky() {
    var bar = document.querySelector('.satt [data-sticky-bar]');
    document.body.style.paddingBottom = bar ? Math.ceil(bar.getBoundingClientRect().height) + 'px' : '';
  }
  window.addEventListener('resize', sticky);

  function init(root) {
    initFilm(root);
    initSlides(root);
    sticky();
    onScroll();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function () { setTimeout(sticky, 0); });
})();
